<template>
	<div>
        <vue-headful :title="'Dashboard :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item active">
	    			<i class="fa fa-dashboard"></i> Dashboard</a>
	    		</li>
                <li class="ml-3" v-if="!isCorrectiveActionUser">
                    <router-link :to="`/dashboards/settings`" class="btn btn-sm btn-white" title="Edit Dashboard" style="border: 1px solid #ddd;">
                        <i class="fa fa-cogs"></i> Settings
                    </router-link>

                    <b-dropdown :html="autoRefreshTitle" variant="default" class="bg-white" size="sm">
                        <b-dropdown-item  @click="setAutoRefresh(1)">
                            Every 1 Minute
                        </b-dropdown-item>
                        <b-dropdown-item  @click="setAutoRefresh(5)">
                            Every 5 Minute
                        </b-dropdown-item>
                        <b-dropdown-item  @click="setAutoRefresh(10)">
                            Every 10 Minute
                        </b-dropdown-item>
                        <b-dropdown-item  @click="setAutoRefresh(null)">
                            Turn Off Auto-Refresh
                        </b-dropdown-item>
                    </b-dropdown>
                </li>
	    	</ol>
	    </h4>

        <template v-if="isCorrectiveActionUser">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            My Assigned Corrective Actions ({{ actionCount }})
                        </div>
                        <div class="card-body">
                            <corrective-action-list ref="correctiveActionDashList" @correctiveActionCount="correctiveActionCount" />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else-if="dashboards.length > 0">

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === 'dashboard_'+dashboard.id" @click="curTab = 'dashboard_'+dashboard.id" v-for="dashboard in dashboards" :key="dashboard.id">
                    {{ dashboard.dashboard_name }}
                    <span class="badge badge-warning" v-if="dashboard.user_id != $store.state.user.user_id" title="This is a Global Dashboard that you are subscribed to. Changed can be made only by the dashboard owner or system admins.">
                        <i class="fa fa-globe"></i>
                    </span>
                </b-nav-item>
            </ul>

            <div v-for="dash in dashboards" v-show="curTab === 'dashboard_'+dash.id">
                <div v-for="row in dash.rows" class="row mb-4">
                    <div v-for="cell in row.cells" :class="'mb-md-0 mb-4 col-md-'+cell.grid_size">
                        <div class="card mb-sm-2 mb-md-0">
                            <div class="card-header">
                                <span v-if="cell.user_filter_id">
                                    {{ $root.getPrettyAssetName(cell.asset_type) }} - <strong>{{ cell.filter_name }} <span v-if="cellCounts[cell.id] !== null">({{ cellCounts[cell.id] }})</span></strong>
                                </span>

                                <span v-else-if="cell.user_report_id">
                                    {{ $root.getPrettyAssetName(cell.report_type) }} - <strong>{{ cell.report_name }}</strong>
                                </span>
                            </div>
                            <div class="card-body" style="max-height: 350px; overflow-y: auto;" v-if="cell.data_type === 'Filter'">
                                <template v-if="cell.asset_type === 'Incident'">
                                    <template v-if="$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/incidents?filter_id='+cell.user_filter_id"
                                            @toggleDashResults="toggleCellDisplay" />


                                        <incident-list v-show="cell.display_type !== 'total' || cell.show_list === true"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @incidentListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Incident Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Inspection'">
                                    <template v-if="$root.hasPermission(['inspections.view.browse', 'inspections.view.own'])">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/inspections?filter_id='+cell.user_filter_id" />

                                        <inspection-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @inspectionListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Inspection Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'SafetyMeeting'">
                                    <template v-if="$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/safety-meetings?filter_id='+cell.user_filter_id" />

                                        <safety-meeting-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @safetyMeetingListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Safety Meeting Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'CorrectiveAction'">
                                    <template v-if="$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.view.assigned'])">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/correctiveactions?filter_id='+cell.user_filter_id" />

                                        <corrective-action-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @correctiveActionCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Corrective Action Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Equipment'">
                                    <template v-if="$root.hasPermission('equipment.view')">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :pluralize="false"
                                            :url="'/equipment?filter_id='+cell.user_filter_id" />

                                        <equipment-list v-show="cell.display_type !== 'total'"
                                        :ref="'dashboardTable'+cell.id"
                                        :dashboardFilters="JSON.parse(cell.table_filters)"
                                        :tableConfig="JSON.parse(cell.table_config)"
                                        @equipmentListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Equipment Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Jobsite'">
                                    <template v-if="$root.hasPermission('jobsites.view')">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/jobsites?filter_id='+cell.user_filter_id" />

                                        <jobsite-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @jobsiteListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Jobsite Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Jsa'">
                                    <template v-if="$root.hasPermission('jsa.view.browse', 'jsa.view.own', 'jsa.manage')">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/jsa?filter_id='+cell.user_filter_id" />

                                        <jsa-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @jsaListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required JSA Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Employee'">
                                    <template v-if="$root.hasPermission('employees.view')">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/employees?filter_id='+cell.user_filter_id" />

                                        <employee-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @empListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Equipment Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Observation'">
                                    <template v-if="$root.hasPermission(['inspections.view.browse', 'inspections.view.own'])">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/observations?filter_id='+cell.user_filter_id" />

                                        <observation-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @obsvListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Inspection/Observation Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'Subcontractor'">
                                    <template v-if="$root.hasPermission('subcontractors.view')">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/subcontractors?filter_id='+cell.user_filter_id" />

                                        <subcontractor-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @subcontractorCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Subcontractor Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'EmployeeTrainingCourse'">
                                    <template v-if="$root.hasPermission('training_courses.view')">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/training-courses/completed?filter_id='+cell.user_filter_id" />

                                        <employee-training-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @empTrainingCourseListCount="setCount($event, cell.id)"
                                            :courseType="'Completed'" />
                                    </template>
                                    <template v-else>
                                        Missing Required Training Course Permission
                                    </template>
                                </template>

                                <template v-else-if="cell.asset_type === 'CovidFormEntry'">
                                    <template v-if="$root.hasPermission(['custom_forms.view', 'custom_forms.manage'])">
                                        <dashboard-total v-if="cell.display_type === 'total' && typeof cellCounts[cell.id] != 'undefined'"
                                            :count="cellCounts[cell.id]"
                                            :cell="cell"
                                            :url="'/custom-forms?filter_id='+cell.user_filter_id" />

                                        <covid-list v-show="cell.display_type !== 'total'"
                                            :ref="'dashboardTable'+cell.id"
                                            :dashboardFilters="JSON.parse(cell.table_filters)"
                                            :tableConfig="JSON.parse(cell.table_config)"
                                            @customFormListCount="setCount($event, cell.id)" />
                                    </template>
                                    <template v-else>
                                        Missing Required Custom Form Permission
                                    </template>
                                </template>
                            </div>

                            <div class="card-body" :style="( (JSON.parse(cell.report_filters)).display[0].id === 'table' ? 'max-height: 500px;' : '' )+' overflow-y: auto;'" v-else-if="cell.data_type === 'Report'">
                                <template v-if="$root.hasPermission('reports.view')">
                                    <template v-if="cell.report_type === 'IncidentTotals'">
                                        <report-incident-totals-display :ref="'dashboardReport'+cell.id"
                                            :filters="JSON.parse(cell.report_filters)"
                                            :report="{id: cell.user_report_id, report_name: cell.report_name}" />
                                    </template>
                                </template>
                                <template v-else>
                                    Missing Required Permission: Reports - View
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <div class="text-center" v-else style="margin-top: 60px;">
            <div class="mb-2">
                <i class="fa fa-cogs"></i> Start Building Custom Dashboard(s) from Saved Filters via the <router-link :to="`/dashboards/settings`">Dashboard Settings</router-link>
            </div>

            <div class="">
                For Tutorials on creating saved filters and dashboards, view <a :href="$root.helpCenterUrl" target="_blank">The MeritEHS Documentation</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                curTab: '',
                dashboards: [],
                actionCount: null,
                timeTilRefresh: null,
                refreshIntervalId: null,
                refreshTimeInMiutes: null,
                cellCounts: {},
            }
        },

        watch: {
            cellCounts(newVal, oldVal){

            },

            timeTilRefresh(newVal, oldVal){
                //Check for Time = 0, then REfresh
                if(newVal === 0)
                {
                    //Fire it
                    this.refreshAllDashboards();
                }
            },
        },

        computed: {
            isCorrectiveActionUser(){
                //Check it
                return (this.$store.state.user.permissions.length === 0 || (this.$store.state.user.permissions.length === 1 && this.$store.state.user.permissions[0] === 'correctiveActions.view.assigned'));
            },

            autoRefreshTitle(){
                //Setup
                var label = 'Auto-Refresh';

                //Check it
                if(this.timeTilRefresh !== null)
                {
                    //Seconds
                    var seconds = (this.timeTilRefresh % 60) + "";

                    //We need to Figure out the time in minutes
                    label += ' - ' + Math.floor(this.timeTilRefresh / 60) + ':' + (seconds.length == 1 ? '0' : '') + seconds;
                }

                //Send it
                return label;
            },
        },

        methods: {

            getDashboards() {
                //Check Setting
                if(this.isCorrectiveActionUser)
                {
                    return;
                }

                this.$http.get('/dashboards')
                .then(response => {
                    //Set it
                    this.dashboards = response.data.dashboards;

                    //SEt Current Tab
                    if(this.dashboards.length > 0)
                    {
                        this.curTab = 'dashboard_'+this.dashboards[0].id;
                    }
                })
                .catch(err => {

                });
            },

            setCount(event, id){
                //Set it
                this.cellCounts[id] = event;

                //Force Update
                this.$forceUpdate();
            },

            correctiveActionCount(count){
                //SEt it
                this.actionCount = count;
            },

            setAutoRefresh(timeInMinutes){
                //Store the setting
                this.refreshTimeInMiutes = timeInMinutes;

                //Check for an existing interval
                if(this.refreshIntervalId)
                {
                    //Clear the Interval
                    clearInterval(this.refreshIntervalId);
                }

                //Check for Null
                if(timeInMinutes == null)
                {
                    //Disable it
                    this.refreshIntervalId = null;
                    this.timeTilRefresh = null;

                    //Stop
                    return;
                }

                //Send it
                this.timeTilRefresh = this.refreshTimeInMiutes * 60;

                //Set the interval
                this.refreshIntervalId = setInterval(() => {
                    //Decremebnt the time Til Refresh
                    this.timeTilRefresh--;
                }, 1000);
            },

            refreshAllDashboards(){
                //REset the Time
                this.timeTilRefresh = this.refreshTimeInMiutes * 60;

                //Alert the User
                this.$toastr.success('Dashboards Refreshed');

                //NOw what?
                for (var i = 0; i < this.dashboards.length; i++)
                {
                    //Rows
                    for (var j = 0; j < this.dashboards[i].rows.length; j++)
                    {
                        //Cells
                        for (var t = 0; t < this.dashboards[i].rows[j].cells.length; t++)
                        {
                            //Call it
                            if(this.dashboards[i].rows[j].cells[t].data_type === 'Filter')
                            {
                                //Refresh the Table
                                this.$refs['dashboardTable'+this.dashboards[i].rows[j].cells[t].id][0].refreshTableData();
                            }
                            else
                            {
                                //Refresh the Report
                                this.$refs['dashboardReport'+this.dashboards[i].rows[j].cells[t].id][0].getData();
                            }
                        }
                    }
                }
            },

            toggleCellDisplay(cell_id){
                //NOw what?
                for (var i = 0; i < this.dashboards.length; i++)
                {
                    //Rows
                    for (var j = 0; j < this.dashboards[i].rows.length; j++)
                    {
                        //Cells
                        for (var t = 0; t < this.dashboards[i].rows[j].cells.length; t++)
                        {
                            //Call it
                            if(this.dashboards[i].rows[j].cells[t].id == cell_id)
                            {
                                //SEt it
                                this.dashboards[i].rows[j].cells[t].show_list = (this.dashboards[i].rows[j].cells[t].show_list === true ? false : true);
                            }
                        }
                    }
                }
            },
        },

        mounted() {
            this.getDashboards();
        }
    }
</script>